document.addEventListener("DOMContentLoaded", function () {
  // NUMU 2026: stop after ~15s instead of polling forever on pages without these elements
  let tries = 0;
  const interval = setInterval(() => {
    const quantityBox = document.querySelector(".mw-option.quantity-box");
    const howPersonalize = document.querySelector(".how-personalize-wrapper");

    if (quantityBox && howPersonalize) {
      quantityBox.insertAdjacentElement("afterend", howPersonalize);

      clearInterval(interval);
    } else if (++tries > 50 || (document.readyState === "complete" && !howPersonalize)) {
      clearInterval(interval);
    }
  }, 300); // check every 300ms
});

let moveCheckTries = 0;
const moveCheck = setInterval(() => {
  const comp = document.querySelector(".custom-complementary-products");
  const paper = document.querySelector(".paper-quality-block");
  // NUMU 2026: journey = Form > Navneflet > Papirkvalitet > Har du brug for mere plads? >
  // Relaterede produkter > Add to cart > Festpakker. If the APO "mere plads" option
  // (css class "more-space-picker") comes after Papirkvalitet, related products go after it.
  const morePlace = document.querySelector(".mw-apo-container .more-space-picker");
  let anchor = paper;
  if (paper && morePlace && (paper.compareDocumentPosition(morePlace) & Node.DOCUMENT_POSITION_FOLLOWING)) {
    anchor = morePlace;
  }

  if (comp && anchor && anchor.parentNode) {
    anchor.parentNode.insertBefore(comp, anchor.nextSibling);
    clearInterval(moveCheck);
  } else if (++moveCheckTries > 50) {
    clearInterval(moveCheck); // NUMU 2026: don't poll forever
  }
}, 300);



let priceCleanerTries = 0;
const priceCleaner = setInterval(() => {
  const options = document.querySelectorAll(".quantity-box select option");

  if (options.length > 0) {
    options.forEach(option => {
      option.textContent = option.textContent.replace(/\(\+DKK [0-9.,]+\)\s*$/, "");
    });

    clearInterval(priceCleaner);
  } else if (++priceCleanerTries > 50) {
    clearInterval(priceCleaner); // NUMU 2026: don't poll forever
  }
}, 300);




document.addEventListener("DOMContentLoaded", function () {
  const ImageQuality = "imgIncreaseQuality_" + Math.random().toString(36).slice(2);

  window[ImageQuality] = setInterval(() => {
    const imgs = document.querySelectorAll(".mw-stack--card__media-wrapper--item img, .mw-stack--card__media-item--crop");

    if (!imgs.length) return;

    imgs.forEach((img) => {
      if (img.src.includes("width=") || img.src.includes("height=")) {
        img.src = img.src
          .replace(/width=\d+/i, "width=2000")
          .replace(/height=\d+/i, "height=2000");
      }
    });

    clearInterval(window[ImageQuality]);
    delete window[ImageQuality];
  }, 300);
});


document.querySelector('.add-cart-wrapper a.custom-add-to-cart')
?.addEventListener('click', function(e) {
  e.preventDefault();
  document.querySelector('button.mw-apo-add-to-cart-custom')?.click();
});

